import config from "../config/config"
import { callService } from "./CommonService";

const APIUrlBase = config.apiHost + config.apiBase + 'occupation-areas';

/* Retrieve list of all occupation areas in the system */
async function getOccupationAreas() {
    const url = APIUrlBase;
    return await callService(url);
}

/* Retrieve one single occupation area data */
async function getOccupationArea(occupationAreaId) {
    const url = APIUrlBase + '/' + occupationAreaId;
    return await callService(url);
}

/* Call API service to update an occupation area */
async function updateOccupationArea(occupationAreaId, data) {
    const url = APIUrlBase + '/' + occupationAreaId;
    const method = 'PATCH';
    const payload = {
        key: data.key,
        name: data.name,
    };
    return await callService(url, method, payload);
}

/* Call API service to create an occupation area */
async function createOccupationArea(data) {
    const url = APIUrlBase;
    const method = 'POST';
    const payload = {
        key: data.key,
        name: data.name,
    };
    return await callService(url, method, payload);
}

/* Call API service to delete an occupation area */
async function deleteOccupationArea(occupationAreaId) {
    const url = APIUrlBase + '/' + occupationAreaId;
    const method = 'DELETE';
    return await callService(url, method);
}

export default { getOccupationAreas, getOccupationArea, updateOccupationArea, createOccupationArea, deleteOccupationArea };
